<!-- 首页新闻版块 -->
<template>
    <div class="newsblock-container">
      <div class="main-box page-content-box" v-loading="dataloading">
        <BlockTitle
          title="新闻动态"
          channelAlias="xinwen"></BlockTitle>
        <template v-if="dataloading == false">
          <div class="focus-news" v-if=" blockItems.length > 0">
            <el-row>
              <el-col class="news-cover-col">
                <div class="news-cover">
                  <a  :href="currItem.video==null ? `/article?id=${currItem.articleId}` : `/player?id=${currItem.articleId}`" target="_blank">
                    <el-image
                        class="cover-img"
                        style="width: 100%;height: 100%;"                        
                          :src="currItem.image == null ? require('@/assets/img/default-cover.jpg') : currItem.image"
                          fit="cover"></el-image>
                  </a>
                </div>
              </el-col>
              <el-col class="news-list-col">
                <div class="news-list">
                    <div
                        v-for="item in blockItems"
                        class="news-list-item"
                        :class="currItem.id == item.id ? 'active-item' : ''"
                        :key="item.id"
                        @mouseenter="onNewsItemClick(item)"
                        >
                        <div class="news-time">
                          <div class="dd">{{ getDay(item.publishDate) }}</div>
                          <div class="yymm">{{ getYearMonth(item.publishDate) }}</div>
                        </div>
                        <div class="news-title">
                          <a  :href="item.video==null ? `/article?id=${item.articleId}` : `/player?id=${item.articleId}`" target="_blank">
                            {{ item.title }}
                          </a>
                        </div>
                    </div>
                </div>
              </el-col>
            </el-row>

          </div>
          <div v-else>
            <el-empty :image-size="100">版块未配置数据</el-empty>
          </div>
        </template>
      </div>

    </div>
</template>
<script>
    import BlockTitle from "@/components/blocks/blocktitle";
    import { getBlockItemList } from "@/api/content";
    import { parseTime } from "@/utils/datetimeUtil"
    import * as channelConfig from "@/config/channels";

    export default{
      components: {BlockTitle},
      props:{},
      data(){
          return {
            blockAlias: channelConfig.blockAlias.BLOCK_ALIAS_XINWENDONGTAI,
            blockItems: [],
            currItem: null,
            dataloading: true,
          };
      },
      methods:{
        onNewsItemClick(item){
          this.currItem = item;
        },

        getDataList(){
          this.dataloading = true;
          getBlockItemList(0, this.blockAlias, 4).then(result => {
            this.dataloading = false;
              if(result.code == 0){
                  if(result.data != null){
                    this.blockItems = result.data;
                    if(this.blockItems != null && this.blockItems.length > 0){
                      this.currItem = this.blockItems[0];
                    }
                  }
              }else{
                  this.blockItems = [];
              }
              //console.log(result.data.list);
          }).catch((err)=>{
            this.dataloading = false;
          });
        },
        getDay(pubdate){
          if(pubdate != null){
            return new Date(pubdate).getDate();
          }else{
            return '';
          }

        },

        getYearMonth(pubdate){
          if(pubdate != null){
            return parseTime(pubdate, "{yyyy}-{mm}");
          }else{
            return '';
          }
        }
      },
      created(){
        this.getDataList();
      },
      mounted(){},
    };
</script>
<style scoped>
.newsblock-container{
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  align-items: center;
  margin: 60px 0px;
}

.main-box{
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    align-items: center;
    /*gap: 40px;*/
 }

.focus-news{
  width: 100%;
  height: 448px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  box-sizing: border-box;
  margin-top: 40px;
}
.el-row{
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  width: 100%;
}
.news-cover-col,
.news-list-col{
  width: 50%;
}
.news-cover{
  margin-right: 15px;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.cover-img{
  transition:all 0.35s ease-in-out;
  overflow: hidden;
}
.cover-img:hover{
  transform: scale(1.1);
  overflow: hidden;
}
.news-list{
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-sizing: border-box;
  height: 100%;
  margin-left: 15px;
  /*gap:16px;*/
  margin-top: -16px;
}

.news-list-item{
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  /*gap: 20px;*/
  flex: 0 0 100px;
  flex-grow: 1;
  box-sizing: border-box;
  margin-top: 16px;
}

.news-time{
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #F9F9F9;
  flex: 0 0 100px;
  height: 100%;
  box-sizing: border-box;
  color: #014289;
}

.news-time .dd{
  font-size: 32px;
  font-weight: normal;
  line-height: 32px;
  text-align: center;
  letter-spacing: 0em;
}

.news-time .yymm{
  font-size: 14px;
  font-weight: normal;
  line-height: 32px;
  letter-spacing: 0em;
}

.news-title{
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 10px 32px;
  gap: 10px;
  flex-grow: 1;
  box-sizing: border-box;
  border-width: 0px 0px 1px 0px;
  border-style: solid;
  border-color: #D8DCE2;
  height: 100%;
  box-sizing: border-box;
  font-size: 20px;
  font-weight: normal;
  line-height: 32px;
  letter-spacing: 0em;
  margin-left: 20px;
}
.news-title a{
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.news-list-item:hover > .news-time,
.active-item > .news-time,
.news-list-item:hover > .news-title,
.active-item > .news-title,
.active-item > .news-title a{
  background: #014289;
  color: #fff;
}

a:hover,
a:focus{
  background: #014289 !important;
  color: rgba(255, 255, 255, 0.8) !important;
}

@media screen and (max-width: 1000px) {
  .newsblock-container{
    margin: 24px 0px;
  }
  /*
  .main-box{
    gap: 20px;
  }
  */
  .focus-news{
    height: auto;
    margin-top: 20px;
  }
  /*
  .news-list-item{
    gap: 10px;
  }
  */
  .news-title{
    margin-left: 10px;
  }
}

@media screen and (max-width: 650px) {
  /*
  .main-box{
    gap: 16px;
  }
  */
  .focus-news{
    height: auto;
    margin-top: 16px;
  }
  .news-list{
    /*gap: 10px;*/
    margin: 0 10px;
    margin-top: -10px;
  }

  .news-cover-col{
    width: 0px;
    display: none;
  }
  .news-list-col{
    width: 100%;
  }
  .news-list-item{
    /*gap: 10px;*/
    flex: 0 0 auto;    
    margin-top: 10px;
  }
  .news-time{    
    flex: 0 0 70px;    
    padding: 10px;
  }
  .news-time .dd{
    font-size: 16px;
    line-height: 20px;
  }
  .news-time .yymm{
    font-size: 12px;
    line-height: 20px;
  }
  .news-title{
    padding: 10px 12px;
    font-size: 14px;
    line-height: 24px;
    margin-left: 10px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/blocks/newsblock/index.vue